export enum PersonalizationSettingsChannelType {
  Sms = 'Sms',
  Push = 'Push',
  Web = 'Web',
}

export type PersonalizationSettingsChannel = {
  type: PersonalizationSettingsChannelType;
  label: string;
  editable: boolean;
  visible: boolean;
  enabled: boolean;
};

export type PersonalizationSettingsEvent = {
  name: string;
  label: string;
  editable: boolean;
  visible: boolean;
  channels: PersonalizationSettingsChannel[];
};

export type PersonalizationSettingsCategory = {
  name: string;
  label: string;
  editable: boolean;
  visible: boolean;
  notifications: PersonalizationSettingsEvent[];
};

export type PersonalizationSettings = {
  categories: PersonalizationSettingsCategory[];
};

export type PersonalizationChannelUpdateData = {
  enabled: boolean;
};

export type PersonalizationCategoryChannelUpdateData = {
  categoryName: string;
  channelType: PersonalizationSettingsChannelType;
  data: PersonalizationChannelUpdateData;
};

export type PersonalizationEventChannelUpdateData = {
  categoryName: string;
  eventName: string;
  channelType: PersonalizationSettingsChannelType;
  data: PersonalizationChannelUpdateData;
};
